import { Dispatch, useEffect, useState } from "react";
import { createGenericContext } from "../../../../utils/createGenericContext";
import clinicalAnalyticsService from "../../../../services/clinical-analytics-service";

export interface IAnalyticsContext {
  filters: IAnalyticsFilters;
  setFilters: Dispatch<React.SetStateAction<IAnalyticsFilters>>;
  filterReport: () => void;
  loading: boolean;
  report: any;
  title: string,
  patientsForFilter: string[]
}

interface IAnalyticsFilters {
  timeframe: string
  formId: string
  accessType: string
  patientCode: string
}

const [useAnalytics, AnalyticsContextProvider] =
  createGenericContext<IAnalyticsContext>();

const AnalyticsProvider = ({ children }: any) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [report, setReport] = useState()
  const [title, setTitle] = useState("")
  const [patientsForFilter, setPatientsForFilter] = useState([])

  const [filters, setFilters] = useState<IAnalyticsFilters>({
    formId: "E889A966-B1A6-43FF-BCAA-C3138A0914F7",
    accessType: "",
    timeframe: "6-months",
    patientCode: "",
  })

  useEffect(() => {
    filterReport()
    clinicalAnalyticsService.getPatientFilter().then(s => setPatientsForFilter(s.data))
  }, []);

  const filterReport = () => {
    setLoading(true);
    
    clinicalAnalyticsService
    .getAnalytics(filters.formId, {
      timeframe: filters.timeframe,
      accessType: filters.accessType, 
      patientCode: filters.patientCode
    })
    .then((res: any) => {
      setReport(res.data);
      setTitle(res.data.name)
      setLoading(false);
    });
  }

  let contextValue = {
    filters,
    filterReport,
    setFilters,
    loading,
    report,
    title,
    patientsForFilter
  };

  return (
    <AnalyticsContextProvider value={contextValue}>
      {children}
    </AnalyticsContextProvider>
  );
};

export { AnalyticsProvider, useAnalytics };
